import React from 'react';
import { PageContainer, PageHeader } from './shared';
import { useUser } from '../hooks/useUser';
import { Box, Typography } from '@mui/material';
import { useTheme } from '../theme';

export default function DashboardPage() {
  const { user } = useUser();
  const { theme } = useTheme();

  return (
    <PageContainer>
      <PageHeader title="Dashboard" />
      <Box
        sx={{
          p: 3,
          background: theme.card.background,
          border: theme.card.border,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: theme.text.primary,
            mb: 2,
          }}
        >
          Welcome, {user?.firstName || 'User'}!
        </Typography>
        <Typography
          sx={{
            color: theme.text.secondary,
          }}
        >
          This is your dashboard. Start building your application here.
        </Typography>
      </Box>
    </PageContainer>
  );
}
